import DashboardPosts from "./dashboard-posts";

export default DashboardPosts;